import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connectionsOptions = z.any()
export type TagsGetAdminSolar_connectionsOptions = z.infer<typeof tagsGetAdminSolar_connectionsOptions>

export const paramsGetAdminSolar_connectionsOptions = z.object({})
export type ParamsGetAdminSolar_connectionsOptions = z.infer<typeof paramsGetAdminSolar_connectionsOptions>

export const querystringGetAdminSolar_connectionsOptions = z.object({ "municipalityId": z.string().uuid().optional() })
export type QuerystringGetAdminSolar_connectionsOptions = z.infer<typeof querystringGetAdminSolar_connectionsOptions>

export const responseGetAdminSolar_connectionsOptions = z.object({ "payload": z.object({ "municipalities": z.array(z.object({ "id": z.string(), "name": z.string() })), "collectionPoints": z.array(z.object({ "id": z.string(), "name": z.string(), "buildingId": z.string(), "buildingName": z.string(), "buildingGroupNames": z.array(z.string()) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connectionsOptions = z.infer<typeof responseGetAdminSolar_connectionsOptions>

interface IGetAdminSolar_connectionsOptions extends BaseMethodType {
  tags: TagsGetAdminSolar_connectionsOptions,
  params: ParamsGetAdminSolar_connectionsOptions,
  querystring: QuerystringGetAdminSolar_connectionsOptions,
  response: ResponseGetAdminSolar_connectionsOptions
}
export const URL = '/admin/solar-connections/options'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connectionsOptions,
    params: paramsGetAdminSolar_connectionsOptions,
    querystring: querystringGetAdminSolar_connectionsOptions,
    response: responseGetAdminSolar_connectionsOptions
  }
}
export interface AdminSolar_connectionsOptions extends BaseRouteType {
  get: IGetAdminSolar_connectionsOptions
}